import {i18n} from '@yourcoach/i18n';

import type {NotificationEvent} from '../../../../../api/event';
import type {EventContextsMap, EventData} from '../types';

import AlarmIcon from '../../../../../assets/icons/alarm.svg';

export const getData = (
  _event: NotificationEvent,
  contexts: EventContextsMap,
): EventData => {
  const {program, task} = contexts;

  return {
    avatar: program?.avatar,
    avatarPlaceholder: program?.title,
    icon: AlarmIcon,
    iconGradient: 'danger',
    title: i18n.t('notifications:task_overdue.title', {
      taskTitle: task?.title,
    }),
  };
};
